import axios from "axios";
import { API_URL } from "../constants";

class AwsService {
    async uploadS3Bucket(images, user_name = false, chasis_no, base_folder) {
        let uploadedUrls = [];

        const formData = new FormData();
        formData.append("chasis_no", chasis_no);
        formData.append("base_folder", base_folder);
        if (user_name) {
            formData.append("user_name", user_name);
        }
        images.forEach((image) => {
            formData.append("images[]", image.originFileObj);
        });

        const response = await axios.post(API_URL + '/s3/upload-images', formData, {
            headers: {
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
                // 'x-authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })

        uploadedUrls = response.data.fileUrls || [];

        return uploadedUrls;
    }

    // CHANGES HIGHLIGHTED: New method for deleting images from AWS S3
    async deleteFromS3Bucket(imagesToDelete) {
        const data = {
            images: imagesToDelete
        }
        await axios.delete(API_URL + '/s3/delete', {
            data,
            headers: {
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
                // 'x-authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
    }
}

const awsService = new AwsService();
export default awsService;
